import { ca } from '@cian/analytics';

import { IJsonQuery } from '../../../packages/api-models/common/json_query';
import {
  IPublicWebV1SearchResponse,
  TPublicWebV1SearchResponse_MlRanking,
} from '../../common/repositories/dailyrent/entities/response/PublicWebV1SearchResponse';

const OFFERS_ON_PAGE = 28;

interface IParams extends Omit<Partial<IPublicWebV1SearchResponse>, 'offers'> {
  offers: IPublicWebV1SearchResponse['offers'] | { id: number; discount?: number }[];
  pageNumber?: number;
  offersCount?: number | undefined;
  jsonQuery: IJsonQuery;
  mlSearchSessionGuid?: string | null | undefined;
  mlRanking?: TPublicWebV1SearchResponse_MlRanking | undefined;
  queryString?: string | null | undefined;
  isDesktop: boolean;
  isHybrid: boolean;
}

export function trackPageOpen({
  pageNumber,
  offersCount,
  offers,
  jsonQuery,
  mlSearchSessionGuid,
  mlRanking,
  queryString,
  isDesktop,
  isHybrid,
}: IParams) {
  const offersPositionOffset = pageNumber ? (pageNumber - 1) * OFFERS_ON_PAGE : undefined;
  const hasOffset = offersPositionOffset !== undefined;

  ca('eventSite', {
    event: 'newpage',
    name: 'newpage',
    category: 'page',
    action: 'newpage',
    label: 'open',
    page: {
      pageType: isHybrid ? 'ListingHybrid' : 'Map',
      siteType: isDesktop ? 'desktop' : 'mobile',
      offersQty: offersCount ?? null,
      pageNumber,
      extra: {
        reason: 'all_objects_on_map',
        mlSearchSessionGuid,
        mlRankingGuid: mlRanking?.guid,
        mlRankingModelVersion: mlRanking?.modelVersion,
      },
      queryString,
    },
    products: offers.reduce(
      (acc, offer, index) => [
        ...acc,
        {
          id: offer.id,
          position: hasOffset ? index + 1 + offersPositionOffset : undefined,
          offerType: 'offer',
          extra: {
            isPriceWithDiscount: Boolean(offer.discount),
          },
        },
      ],
      [],
    ),
    sc: jsonQuery,
  });
}
